import React from "react";
import { Datagrid, DateField, List, TextField } from "react-admin";
import { Message } from "../../models";

export const HistoryList = ({
  threadId,
  userId,
  setSelected,
}: {
  threadId: string;
  userId: string;
  setSelected: (record: Message) => void;
}) => {
  return (
    <List
      resource={`/admin/users/${userId}/threads/${threadId}/history`}
      pagination={false}
      exporter={false}
      title={
        <span style={{ marginLeft: "10px" }}>
          thread id: <strong>{threadId}</strong>
        </span>
      }
    >
      <Datagrid
        bulkActionButtons={false}
        rowSx={(record) => ({
          backgroundColor:
            record.type === "human"
              ? "#ffe0e0" // light red for delayed
              : record.type === "ai"
              ? "#e0ffe0" // light green for completed
              : "inherit", // default
        })}
        rowClick={(_, __, record) => {
          setSelected(record as Message);
          // Return undefined so RA won’t navigate
          return undefined as unknown as any;
        }}
      >
        <DateField
          showTime
          source="response_metadata.timestamp"
          label="Date"
          sortable={false}
          sx={{
            whiteSpace: "nowrap", // keep \n and spaces
          }}
        />
        <TextField source="type" label="Type" sortable={false} />
        <TextField
          source="content"
          label="Message"
          sortable={false}
          sx={{
            whiteSpace: "pre-wrap", // keep \n and spaces
            wordBreak: "break-word", // wrap long words
            fontFamily:
              'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          }}
        />
      </Datagrid>
    </List>
  );
};
